/* International free-delivery goal in the shopper's own currency.
 *
 * Every non-GB zone ships free at £120 (snippets/runit-ship-goal.liquid). Liquid has no exchange
 * rate, so this converts 120 GBP with Shopify.currency.rate, rounds UP to the next 10 and saves
 * it on the cart as _rl_ship_goal = "EUR:14500" (underscore = hidden at checkout). The drawer's
 * progress bar and gap-closer rail read it on their next render.
 *
 * Rounding up is the rule that keeps the bar honest: reaching the shown amount always converts
 * back to at least £120.
 */
(function () {
  var GOAL_GBP = 120;

  function roundedGoal(rate) {
    // Up to the next 10 (€140.4 -> €150; 1,402.8 kr -> 1,410; ¥21,030 stays). Never down: the shown
    // goal must convert back to at least £120.
    return Math.ceil(GOAL_GBP * rate / 10 - 1e-9) * 10;
  }

  window.rlShipGoal = { roundedGoal: roundedGoal };

  var cur = window.Shopify && window.Shopify.currency;
  var country = window.Shopify && window.Shopify.country;
  if (!cur || !cur.active || cur.active === 'GBP' || country === 'GB') return;
  var rate = parseFloat(cur.rate);
  if (!(rate > 0)) return;
  var want = cur.active + ':' + Math.round(roundedGoal(rate) * 100);

  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if ((cart.attributes || {})._rl_ship_goal === want) return;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _rl_ship_goal: want } })
      });
    })
    .catch(function () {});
})();
